export const iconFontAwesomeChildhoodPersonBiking = (
	<i className="fa-solid fa-person-biking"></i>
);
